import script from "./PandoraButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraButton.vue?vue&type=script&setup=true&lang=js"

import "./PandoraButton.vue?vue&type=style&index=0&id=22e3be98&lang=css"

const __exports__ = script;

export default __exports__